import React from "react";
import { Icon } from "antd";
import { useTranslation } from "react-i18next";
import { SeparateNumberFormat } from "../../../../../services/utils";
import CollapsibleSection from "./CollapsibleSection";

const getStreamUrl = (token) => {
  if (!token) return null;
  if (typeof token === "string") return token;
  return token.stream_url || token.embed_url || token.url || null;
};

const CameraFeed = ({ token }) => {
  const { t } = useTranslation();
  const url = getStreamUrl(token);

  if (url) {
    return (
      <div className="cameras__feed">
        <iframe title="camera" src={url} frameBorder="0" allowFullScreen />
      </div>
    );
  }

  return (
    <div className="cameras__feed cameras__feed--empty">
      <Icon type="video-camera" />
      <span>{t("Live camera not available")}</span>
    </div>
  );
};

const ScreenCamerasSection = ({ display }) => {
  const { t } = useTranslation();
  const tokens = display.camlytics_tokens;

  if (!tokens) return null;

  const trafficToken = tokens.traffic || (Array.isArray(tokens) ? tokens[0] : tokens);
  const screenToken = tokens.screen || (Array.isArray(tokens) ? tokens[1] : null);
  const trafficToday = tokens.traffic_today != null ? tokens.traffic_today : display.traffic_today;

  return (
    <CollapsibleSection title={t("Live cameras")}>
      <div className="cameras">
        <div className="cameras__col">
          <div className="cameras__label">{t("Traffic")}</div>
          <CameraFeed token={trafficToken} />
        </div>

        <div className="cameras__col">
          <div className="cameras__label">{t("Today's traffic")}</div>
          <div className="cameras__today">
            <Icon type="team" className="cameras__today-icon" />
            <span className="cameras__today-value">
              {trafficToday != null ? SeparateNumberFormat(trafficToday) : "—"}
            </span>
          </div>
          <div className="cameras__label">{t("Screen")}</div>
          <CameraFeed token={screenToken} />
        </div>
      </div>
    </CollapsibleSection>
  );
};

export default ScreenCamerasSection;
